/*
 * Office.com event schema follows Office Event Schema
 * https://microsoft.sharepoint-df.com/:x:/t/Taos/EdW5WNM9LC1Nr445nF3mFyEBHJjkJRUz8uBUhJsdMxN6nw?e=ekTcUg
 * Office Event Schema https://www.owiki.ms/wiki/Telemetry/instrumentaton/Office_Event_Schema
 */
// Office Event Schema Required Part A: Common properties, some of the fields need to be set in order for the data to be processed in COSMOS
export var EVENT = 'Event';
export var RELEASE = 'Release';
// Office Event Schema Custom Part A: Common properties for every event
export var REQUEST_ORIGIN = 'RequestOrigin';
export var USER_SEGMENT = 'UserSegment';
export var USER_TYPE = 'UserType';
export var EVENT_SCHEMA_VERSION = 'EventSchemaVersion';
export var BROWSER_SESSION_ID = 'BrowserSessionId';
export var DEPLOYMENT_ENV = 'DeploymentEnvironment';
export var SERVER_LOCATION = 'Geo';
export var FLIGHTS = 'Flights';
export var DEVICE_TYPE = 'DeviceType';
export var APP_WORKLOAD = 'AppWorkload';
//Office Event Schema Custom Part C: Custom properties for different event category
export var EVENT_CATEGORY = 'EventCategory';
export var PAGE_VIEW_DETAILS = 'PageView';
export var ACTION_DETAILS = 'Action';
// `Release` nested field Name
export var AUDIENCE_GROUP = 'AudienceGroup';
// `UserSegment` nested field Name
export var IS_ADMIN = 'IsAdmin';
export var IS_DYNAMICS = 'IsDynamics';
export var IS_EDU = 'IsEdu';
export var IS_EDU_FACULTY = 'IsEduFaculty';
export var IS_EDU_STUDENT = 'IsEduStudent';
export var IS_FIRST_VISIT = 'IsFirstVisit';
export var IS_IW = 'IsIw';
export var IS_SMB = 'IsSmb';
// `PageViewDetails` nested field Name
export var PAGE_APP_NAME = 'AppName';
export var PAGE_NAME = 'PageName';
export var PAGE_TYPE = 'PageType';
export var IS_INTENTIONAL = 'IsIntentional';
// `Action` nested field Name
export var ACTION_TARGET = 'Target';
export var ACTION_RESULT = 'Result';
export var ACTION_TYPE = 'Type';
export var AREA = 'Area';
export var SUB_AREA = 'SubArea';
export var ID = 'Id';
// `Analysis` nested field Name
export var INDEX = 'Index';
export var RESOURCE_ID = 'ResourceId';
export var DOCUMENT_ID = 'DocumentId';
export var IMPRESSION_ID = 'ImpressionId';
export var ITEM_CATEGORY = 'ItemCategory';
// `Request` nested field Name
export var HTTP_CODE = 'HttpCode';
export var ERROR = 'Error';
export var FROM_CACHE = 'FromCache';
// `ErrorType` nested field Name
export var ERROR_TYPE = 'ErrorType';
// `Performance` and `Request` nested field Name
export var LATENCY = 'Latency';
//# sourceMappingURL=FieldNames.js.map